import { Link } from 'react-router-dom';

const features = [
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
        <line x1="8" y1="21" x2="16" y2="21"></line>
        <line x1="12" y1="17" x2="12" y2="21"></line>
      </svg>
    ),
    title: 'Custom Design',
    description: 'Each landing page is uniquely designed based on your specific requirements and business needs.',
    highlight: 'Tailored specifically for your audience',
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <polyline points="12 6 12 12 16 14"></polyline>
      </svg>
    ),
    title: 'Quick Turnaround',
    description: 'Your custom landing page will be ready in minutes, not days. We generate options instantly.',
    highlight: 'Start converting visitors faster',
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="4 17 10 11 4 5"></polyline>
        <line x1="12" y1="19" x2="20" y2="19"></line>
      </svg>
    ),
    title: 'No Traffic Limits',
    description: 'Your success shouldn\'t cost you more. Get unlimited traffic without worrying about overages or downtimes.',
    highlight: 'Scale worry-free as you grow',
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <path d="M8 14s1.5 2 4 2 4-2 4-2"></path>
        <line x1="9" y1="9" x2="9.01" y2="9"></line>
        <line x1="15" y1="9" x2="15.01" y2="9"></line>
      </svg>
    ),
    title: 'Hassle-Free Process',
    description: 'Share your requirements with us, and we handle everything from design to deployment of your custom landing page.',
    highlight: 'No technical knowledge required',
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
      </svg>
    ),
    title: 'Blazing Fast Speed',
    description: 'Optimized code and lightning-quick page loads delivered via our worldwide CDN network for maximum performance.',
    highlight: 'Better user experience, better results',
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
        <line x1="12" y1="18" x2="12.01" y2="18"></line>
      </svg>
    ),
    title: 'Mobile Optimized',
    description: 'Every landing page is fully responsive and looks stunning on all devices, from desktops to smartphones.',
    highlight: 'Reach customers everywhere',
  },
];

const steps = [
  {
    number: '1',
    title: 'Simple Order Process',
    description: 'Our streamlined ordering process walks you through a few quick questions about your needs. Tell us what you\'re looking for, share any design preferences, and provide your branding guidelines.',
    details: ['Answer a few questions', 'Provide specific requirements', 'Share design preferences'],
  },
  {
    number: '2',
    title: 'Review Your Designs',
    description: 'Once complete, you\'ll receive 3 unique landing page previews to review. Pick your favorite or request regeneration for new options.',
    details: ['Preview your landing pages', 'Compare 3 unique options', 'Unlimited regenerations'],
  },
  {
    number: '3',
    title: 'Deploy & Profit!',
    description: 'Once you\'ve selected your favorite, pay and your production URL is live instantly. Start driving traffic and converting visitors immediately!',
    details: ['Receive your live URL', 'Start driving traffic', 'Begin converting visitors'],
  },
];

const benefits = [
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
        <circle cx="8.5" cy="8.5" r="1.5"></circle>
        <polyline points="21 15 16 10 5 21"></polyline>
      </svg>
    ),
    title: 'Visually Stunning',
    description: 'Professionally designed to impress your visitors and convert them into customers.',
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
    ),
    title: 'No Hidden Costs',
    description: 'One simple price for design, unlimited traffic, and affordable hosting with no surprises.',
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
        <polyline points="22 4 12 14.01 9 11.01"></polyline>
      </svg>
    ),
    title: 'Ready To Launch',
    description: 'Everything you need in one package - hosting, design, and optimization included.',
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
        <path d="M9 9h6v6H9z"></path>
      </svg>
    ),
    title: 'Cancel Anytime',
    description: 'No long-term contracts or commitments. Pay month-to-month and cancel whenever you want.',
  },
];

export function HomePage() {
  return (
    <div>
      {/* Hero Section - Teal/Cyan Gradient */}
      <section className="relative overflow-hidden py-24 md:py-32" style={{ background: 'linear-gradient(135deg, #a7ffeb 0%, #84ffff 100%)' }}>
        {/* Decorative pattern overlay */}
        <div
          className="absolute inset-0 opacity-30"
          style={{
            backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'><path d='M95,50 C95,75 75,95 50,95 C25,95 5,75 5,50 C5,25 25,5 50,5 C75,5 95,25 95,50 Z' fill='none' stroke='%23ffffff' stroke-width='0.5' /></svg>")`,
          }}
        />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="text-center max-w-3xl mx-auto">
            <span className="inline-block text-accent-500 text-xl md:text-2xl font-medium mb-4 italic drop-shadow-sm">
              Really, really, ridiculously good landing pages
            </span>
            <h1 className="text-4xl md:text-6xl font-extrabold mb-6 leading-tight text-primary-500 uppercase tracking-tight" style={{ textShadow: '3px 3px 0 rgba(255, 64, 129, 0.2)' }}>
              Custom Landing Pages
              <br />
              <span className="text-primary-400">Simple Price</span>
            </h1>
            <p className="text-xl text-text-secondary mb-8 max-w-2xl mx-auto">
              Get a professionally designed landing page tailored to your specific needs with minimal hosting fees and no traffic limits. We generate 3 options in minutes. Convert more visitors with less hassle.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/generate"
                className="btn-primary text-lg px-8 py-4"
              >
                Order Your Page Today
                <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </Link>
            </div>
            <p className="mt-6 text-text-secondary text-sm font-medium">
              Preview for free &bull; $50 one-time + $5/month hosting
            </p>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-white relative overflow-hidden">
        {/* Subtle dot pattern */}
        <div
          className="absolute inset-0 opacity-50"
          style={{
            backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'><circle cx='20' cy='20' r='1' fill='%233f51b5' opacity='0.05' /></svg>")`,
          }}
        />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="text-center mb-16">
            <h2 className="section-title">
              Why Choose Zlandr?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature) => (
              <div key={feature.title} className="card-hover group">
                <div className="feature-icon">{feature.icon}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="text-text-secondary mb-3 leading-relaxed">{feature.description}</p>
                <span className="feature-highlight">{feature.highlight}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-20 bg-gray-50 relative overflow-hidden">
        {/* Subtle dot pattern */}
        <div
          className="absolute inset-0 opacity-50"
          style={{
            backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20'><circle cx='10' cy='10' r='1' fill='%233f51b5' opacity='0.05' /></svg>")`,
          }}
        />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="text-center mb-16">
            <h2 className="section-title">
              How It Works
            </h2>
          </div>

          <div className="max-w-4xl mx-auto">
            {steps.map((step, index) => (
              <div key={step.number} className="flex mb-12 last:mb-0 group">
                {/* Timeline line */}
                <div className="relative flex flex-col items-center mr-8">
                  <div className="step-number">{step.number}</div>
                  {index < steps.length - 1 && (
                    <div className="w-1 flex-1 bg-gradient-to-b from-primary-500 to-accent-500 rounded-full" />
                  )}
                </div>

                {/* Content card */}
                <div className="flex-1 card group-hover:shadow-lg group-hover:border-primary-200 transition-all duration-300">
                  <h3 className="text-xl font-semibold text-primary-500 mb-3 uppercase tracking-tight relative inline-block">
                    {step.title}
                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-primary-500 to-accent-500 group-hover:w-full transition-all duration-300" />
                  </h3>
                  <p className="text-text-secondary mb-4 leading-relaxed">{step.description}</p>
                  <div className="flex flex-wrap gap-2">
                    {step.details.map((detail) => (
                      <span key={detail} className="step-pill">
                        {detail}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-20 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #f5f5f5 0%, #e0f7fa 100%)' }}>
        {/* Decorative pattern */}
        <div
          className="absolute inset-0 opacity-40"
          style={{
            backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'><path d='M85,50 C85,69 69,85 50,85 C31,85 15,69 15,50 C15,31 31,15 50,15 C69,15 85,31 85,50 Z' fill='none' stroke='%233f51b5' stroke-width='0.2' /></svg>")`,
          }}
        />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="text-center mb-16">
            <h2 className="section-title">
              Ready For Your Custom Landing Page?
            </h2>
          </div>

          <div className="flex flex-col lg:flex-row gap-10 max-w-5xl mx-auto">
            {/* Benefits panel */}
            <div className="lg:w-2/5 space-y-6">
              {benefits.map((benefit) => (
                <div
                  key={benefit.title}
                  className="bg-white p-6 rounded-2xl shadow-lg flex items-start gap-5 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl border-l-4 border-transparent hover:border-primary-500"
                >
                  <div className="flex items-center justify-center w-12 h-12 rounded-xl text-primary-500 transition-all duration-300 group-hover:bg-primary-500 group-hover:text-white" style={{ background: 'linear-gradient(135deg, rgba(63, 81, 181, 0.1) 0%, rgba(255, 64, 129, 0.1) 100%)' }}>
                    {benefit.icon}
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-semibold text-primary-500 mb-2">{benefit.title}</h4>
                    <p className="text-text-secondary text-sm leading-relaxed">{benefit.description}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Price card */}
            <div className="lg:w-3/5">
              <div className="bg-white rounded-3xl shadow-xl overflow-hidden border-2 border-primary-200 hover:border-primary-500 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl">
                {/* Header */}
                <div className="p-10 text-center border-b-2 border-primary-100" style={{ background: 'linear-gradient(135deg, #f5f9ff 0%, #f0f7fa 100%)' }}>
                  <h3 className="text-2xl font-semibold text-primary-500 mb-6 uppercase tracking-tight">Custom Landing Page</h3>
                  <div className="flex items-center justify-center gap-4 mb-4">
                    <div className="text-6xl font-extrabold text-primary-500">
                      $50<span className="text-xl text-gray-500 font-normal">/page</span>
                    </div>
                    <div className="text-4xl font-semibold text-accent-500">+</div>
                    <div className="text-6xl font-extrabold text-primary-500">
                      $5<span className="text-xl text-gray-500 font-normal">/month</span>
                    </div>
                  </div>
                  <p className="text-text-secondary italic">Professional design with affordable hosting</p>
                </div>

                {/* Features */}
                <div className="p-8">
                  <ul className="space-y-4">
                    {[
                      'Custom design based on your needs',
                      'Friendly hosting for only $5/month',
                      'No traffic limits or overage fees',
                      'Cancel hosting anytime',
                      '3 unique design options',
                      'Unlimited regenerations',
                      'Contact form with email notifications',
                      'Analytics dashboard',
                    ].map((feature, i) => (
                      <li
                        key={feature}
                        className={`flex items-center text-text-secondary transition-all duration-300 hover:translate-x-1 hover:text-primary-500 ${i === 4 ? 'bg-primary-50 -mx-4 px-4 py-2 rounded-lg border-l-4 border-primary-500 font-semibold text-primary-500' : ''}`}
                      >
                        <svg className="w-5 h-5 text-primary-500 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Footer */}
                <div className="p-8 pt-0">
                  <Link to="/generate" className="btn-primary w-full text-lg py-4 justify-center">
                    <span>Order Your Page Now</span>
                    <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </Link>
                </div>
              </div>

              <p className="text-center text-text-secondary mt-6 text-sm">
                Want a custom subdomain? Add just $5/month.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20" style={{ background: 'linear-gradient(135deg, #3f51b5 0%, #5c6bc0 100%)' }}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 uppercase tracking-tight">
            Ready to Launch Your Landing Page?
          </h2>
          <p className="text-xl text-white/80 mb-8">
            Get a professionally designed landing page that converts visitors into customers.
          </p>
          <Link
            to="/generate"
            className="btn bg-white text-primary-600 hover:bg-gray-100 text-lg px-8 py-4 inline-flex items-center font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
          >
            Order Your Page Now
            <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </Link>
        </div>
      </section>
    </div>
  );
}
